<!--
  ChangelogErrorState.vue
  
  Error state displayed when changelog fails to load.
  
  @component
-->
<template>
  <div class="text-center py-12">
    <!-- Error Icon -->
    <div class="text-red-500 mb-2">
      <svg class="w-12 h-12 mx-auto" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
          d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
        />
      </svg>
    </div>

    <!-- Error Message -->
    <p class="text-charcoal-300">
      {{ message }}
    </p>
  </div>
</template>

<script setup lang="ts">
/**
 * Props for the ChangelogErrorState component
 */
interface Props {
  /** Error message to display to the user */
  message: string
}

defineProps<Props>()
</script>
